<template>
  <div
    class="min-h-screen flex justify-center items-center flex-col bg-gray-200"
  >
    <inertia-head>
      <title>{{ status + "- " + title }}</title>
    </inertia-head>
    <p class="text-primary-color font-extrabold text-7xl">{{ status }}</p>
    <p class="mt-4 text-5xl font-extrabold">{{ title }}</p>
    <p class="mt-3 text-lg text-gray-600">{{ description }}</p>
    <inertia-link
      :href="$route('home')"
      class="mt-6 link text-lg font-bold flex items-center"
      >Go to Homepage <font-awesome-icon icon="angle-right" class="ml-1"
    /></inertia-link>
  </div>
</template>

<script>
export default {
  props: {
    status: Number,
  },
  computed: {
    title() {
      return {
        503: "Service Unavailable",
        500: "Server Error",
        404: "Page Not Found",
        403: "Forbidden",
        405: "Method Not Allowed",
      }[this.status];
    },
    description() {
      return {
        503: "Sorry, we are doing some maintenance. Please check back soon.",
        500: "Whoops, something went wrong on our servers.",
        404: "Sorry, the page you are looking for could not be found.",
        403: "Sorry, you are forbidden from accessing this page.",
        405: "Sorry, the requested method is not allowed on this server.",
      }[this.status];
    },
  },
};
</script>